exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Basics_FormTitle_t4Wvi {\n    color: #337ab7;\n    margin: auto;\n    align-items: left;\n    display: flex;\n    flex-flow: row;\n    justify-content: left;\n    font-size: 18px;\n    font-weight: bolder;\n    margin: 10px 0px 0 20px;\n}\n\n.Basics_formLayout_1XrsI {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    justify-content: space-between;\n    row-gap: 10px;\n}\n\n.Basics_box_3nk8y {\n    border: 1px solid grey;\n    /* box-shadow: black; */\n    border-radius: 5px;\n    margin: 5px;\n    padding: 20px;\n}", ""]);

// Exports
exports.locals = {
	"FormTitle": "Basics_FormTitle_t4Wvi",
	"formLayout": "Basics_formLayout_1XrsI",
	"box": "Basics_box_3nk8y"
};